<template>
  <ul class="scroll-online" v-if="$store.state.scrollOnline">
    <li title="设计师招募">
      <router-link :to="{path:'/settled_school'}">
        <i class="el-icon-circle-plus-outline"></i>
        <span class="recruit">学校入驻</span>
      </router-link>
    </li>
    <!-- <li>
      <a title="关注官方微信">
        <i class="erweima"></i>
        <img class="code" :src="official" alt />
      </a>
    </li> -->
    <li @click="openZxDialog">
      <a title="联系在展客服" href="javascript:;">
        <i class="server"></i>
      </a>
    </li>

    <li @click="goTop">
      <a title="回到顶部">
        <i class="top"></i>
      </a>
    </li>
  </ul>
</template>

<script>
import official from "@/assets/img/erweima/official.jpg";

export default {
  data() {
    return {
      official: official
    };
  },
  computed: {
    designer() {
      return this.$store.state.designer;
    }
  },

  methods: {
    //联系华转客服
    openZxDialog() {
      window.open(
        "http://p.qiao.baidu.com/cps/chat?siteId=12321420&userId=25956497",
        "免费咨询",
        "alwaysRaised=yes,width=800,height=600,location=no,menubar=no,toolbar=no,status=no"
      );
    },
    // 返回顶部
    goTop() {
      let timer = null;
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop <= 0) return;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (scrollTop > 0) {
          scrollTop -= 100;
          document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
          requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
//在线咨询
.scroll-online {
  position: fixed;
  width: 48px;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  z-index: 1111111111;
  li:last-child {
    margin-bottom: 0;
  }
  li {
    width: 48px;
    height: 48px;
    background: #fff;
    text-align: center;
    line-height: 48px;
    border: 1px solid #dedede;
    margin-bottom: 10px;
    position: relative;
    cursor: pointer;
    a {
      display: block;
      width: 100%;
      height: 100%;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      .el-badge__content {
        background-color: #d13939 !important;
      }
    }
    .code {
      position: absolute;
      bottom: 0;
      left: -115px;
      width: 100px;
      height: 100px;
      z-index: 99999999;
      display: none;
      box-shadow: 0px 0px 8px 0px #47484b;
    }
  }
  i {
    color: #848896;
    font-size: 26px;
    // margin-right: 0 !important;
    vertical-align: middle;
  }
  .erweima,
  .server,
  .top {
    width: 26px;
    height: 26px;
    display: block;
    margin: 11px auto;
  }
  .erweima {
    background-image: url(../assets/img/scroll-online/erweima1.png);
  }
  .server {
    background-image: url(../assets/img/scroll-online/server1.png);
  }
  .top {
    margin-top: 16px;
    background: url(../assets/img/scroll-online/top1.png) no-repeat;
  }
  .recruit {
    width: 100px;
    height: 48px;
    background-color: #fff;
    position: absolute;
    display: none;
    left: -110px;
    bottom: 0;
    color: #4b5062;
    font-size: 14px;
  }
  li:hover {
    background: #111111;
    border-color: #111111;
    i {
      color: #fff;
    }
    .erweima {
      background-image: url(../assets/img/scroll-online/erweima2.png);
    }
    .server {
      background-image: url(../assets/img/scroll-online/server2.png);
    }
    .top {
      margin-top: 16px;
      background: url(../assets/img/scroll-online/top2.png) no-repeat;
    }
    .code {
      display: block;
    }
    .recruit {
      display: block;
    }
  }
}
</style>
